/* Posture Lift one-pager (USA-thema). Nagebouwd op de NL-pagina mv-posture-offer, zonder NL-tracking.
   Eén bestand voor alle mv-aanbod-secties; elke sectie heeft data-mva="<soort>" en wordt één keer opgestart
   (ook na een herlaadbeurt in de theme editor). Alle zichtbare tekst komt uit de sectie-instellingen.
   Prijsregel = de kortingsfunctie (usa/apps/mv-us-functies/extensions/mv-bundels/src/bundels.js):
   grootste bundel met aantal <= N, bundelprijs per stuk maal N, op centen afgerond. */
(function () {
  "use strict";
  if (window.mvAanbod) return;

  function tc(n) { return (n < 10 ? "0" : "") + n; }
  function vul(tekst, waarden) {
    return String(tekst || "").replace(/\[(\w+)\]/g, function (m, k) { return k in waarden ? waarden[k] : m; });
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function geldFormat(valuta) {
    var f;
    try { f = new Intl.NumberFormat("en-US", { style: "currency", currency: valuta || "USD" }); }
    catch (e) { f = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }); }
    return function (centen) { return f.format(centen / 100); };
  }

  // Verzenddatum: na de cut-off een dag later, weekend overslaan. Zegt "verzonden", niet "geleverd".
  function verzenddatum(cutoff) {
    var d = new Date();
    if (d.getHours() >= cutoff) d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    return new Intl.DateTimeFormat("en-US", { weekday: "short", month: "short", day: "numeric" }).format(d);
  }
  function cutoffUitPagina() {
    var data = document.querySelector("[data-mva-data]");
    try { return data ? JSON.parse(data.textContent).cutoff : 17; } catch (e) { return 17; }
  }
  function vulVerzenddata() {
    var datum = verzenddatum(cutoffUitPagina());
    document.querySelectorAll("[data-mva-verzend]").forEach(function (el) { el.textContent = datum; });
  }

  // ── Kop: aftelklok tot middernacht, hoogte van de promobalk, sticky productbalk ──
  function initKop(root) {
    var klok = root.querySelector("[data-mva-klok]");
    if (klok) {
      var u = klok.querySelector("[data-u]"), m = klok.querySelector("[data-m]"), s = klok.querySelector("[data-s]");
      var tik = function () {
        var nu = new Date();
        var midder = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate() + 1);
        var over = Math.max(0, Math.floor((midder - nu) / 1000));
        u.textContent = tc(Math.floor(over / 3600));
        m.textContent = tc(Math.floor(over / 60) % 60);
        s.textContent = tc(over % 60);
      };
      tik();
      setInterval(tik, 1000);
    }
    var balk = root.querySelector("[data-mva-actiebalk]");
    var meet = function () {
      document.documentElement.style.setProperty("--mva-balkh", (balk ? balk.offsetHeight : 0) + "px");
    };
    meet();
    window.addEventListener("resize", meet, { passive: true });

    // Productbalk zodra de hoofdknop uit beeld is. De grens wordt gemeten bij een layoutwijziging,
    // niet bij elke scroll (een reflow per scroll-tik laat mobiel haperen).
    var pbalk = root.querySelector("[data-mva-pbalk]");
    if (!pbalk) return;
    var BOVENZONE = 240, SPELING = 24, grens = 0;
    var meetGrens = function () {
      var cta = document.querySelector("[data-mva-hoofdcta]");
      grens = cta ? cta.getBoundingClientRect().bottom + window.scrollY : 600;
    };
    meetGrens();
    window.addEventListener("load", meetGrens);
    if (window.ResizeObserver) new ResizeObserver(meetGrens).observe(document.body);
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      if (y <= BOVENZONE) { pbalk.classList.remove("is-zichtbaar"); return; }
      if (y > grens + SPELING) pbalk.classList.add("is-zichtbaar");
      else if (y < grens - SPELING) pbalk.classList.remove("is-zichtbaar");
    }, { passive: true });
  }

  // ── Hero: galerij, tabbladen, bundelkaarten, reserveringsteller, klantvideo ──
  function initHero(root) {
    var geld = geldFormat(root.dataset.valuta);

    var galerij = root.querySelector("[data-mva-galerij]");
    if (galerij) {
      var beeld = galerij.querySelector("[data-mva-hoofdbeeld]");
      var speler = galerij.querySelector("[data-mva-hoofdvideo]");
      var duimen = [].slice.call(galerij.querySelectorAll(".mva-galerij__duim"));
      var nu = 0;
      var toon = function (i) {
        if (!duimen.length) return;
        nu = (i + duimen.length) % duimen.length;
        var d = duimen[nu];
        if (d.dataset.video) {
          if (speler.getAttribute("src") !== d.dataset.video) {
            if (d.dataset.poster) speler.poster = d.dataset.poster;
            speler.src = d.dataset.video;
          }
          if (beeld) beeld.hidden = true;
          speler.hidden = false;
          speler.play().catch(function () {});
        } else {
          speler.pause();
          speler.hidden = true;
          if (beeld && d.dataset.groot) {
            beeld.hidden = false;
            beeld.removeAttribute("srcset");
            beeld.src = d.dataset.groot;
            beeld.alt = d.dataset.alt || "";
          }
        }
        duimen.forEach(function (x, j) { x.classList.toggle("is-actief", j === nu); });
      };
      duimen.forEach(function (d, i) { d.addEventListener("click", function () { toon(i); }); });
      var vorige = galerij.querySelector("[data-mva-vorige]"), volgende = galerij.querySelector("[data-mva-volgende]");
      if (vorige) vorige.addEventListener("click", function () { toon(nu - 1); });
      if (volgende) volgende.addEventListener("click", function () { toon(nu + 1); });
      // Vegen: alleen horizontaal reageren, een verticale veeg is scrollen.
      var vak = galerij.querySelector(".mva-galerij__hoofd"), x0 = 0, y0 = 0;
      if (vak && duimen.length > 1) {
        vak.addEventListener("touchstart", function (e) { x0 = e.changedTouches[0].clientX; y0 = e.changedTouches[0].clientY; }, { passive: true });
        vak.addEventListener("touchend", function (e) {
          var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          toon(dx < 0 ? nu + 1 : nu - 1);
        }, { passive: true });
      }
      // Is de eerste dia een video, dan meteen spelen.
      if (duimen[0] && duimen[0].dataset.video) toon(0);
    }

    var tabs = root.querySelector("[data-mva-tabs]");
    if (tabs) {
      var knoppen = [].slice.call(tabs.querySelectorAll('[role="tab"]'));
      knoppen.forEach(function (k) {
        k.addEventListener("click", function () {
          knoppen.forEach(function (b) {
            var aan = b === k;
            b.setAttribute("aria-selected", String(aan));
            var vak = document.getElementById(b.getAttribute("aria-controls"));
            if (vak) vak.hidden = !aan;
            var vid = vak && vak.querySelector("video");
            if (vid) { if (aan) vid.play().catch(function () {}); else vid.pause(); }
          });
        });
      });
    }

    var klant = root.querySelector("[data-mva-klantvideo]");
    if (klant) {
      var kv = klant.querySelector("video"), geluid = klant.querySelector("[data-mva-geluid]");
      if (kv && geluid) {
        geluid.addEventListener("click", function () {
          kv.muted = !kv.muted;
          geluid.textContent = kv.muted ? klant.dataset.uit : klant.dataset.aan;
          if (kv.paused) kv.play().catch(function () {});
        });
      }
    }

    var bundels = [].slice.call(root.querySelectorAll(".mva-bundel"));
    var cta = root.querySelector("[data-mva-hoofdcta]");
    var kies = function (el) {
      bundels.forEach(function (b) { b.setAttribute("aria-checked", String(b === el)); });
      if (!cta) return;
      var totaal = Number(el.dataset.totaal), vol = Number(el.dataset.vol);
      var oud = cta.querySelector("[data-mva-oud]"), nieuw = cta.querySelector("[data-mva-nu]");
      if (nieuw) nieuw.textContent = geld(totaal);
      if (oud) oud.textContent = vol > totaal ? geld(vol) : "";
    };
    bundels.forEach(function (b) {
      b.addEventListener("click", function () { kies(b); });
      b.addEventListener("keydown", function (e) {
        if (e.key === " " || e.key === "Enter") { e.preventDefault(); kies(b); }
      });
    });

    // Reserveringsteller: loopt één keer af en blijft dan staan met een uitleg, niet opnieuw beginnen.
    var res = root.querySelector("[data-mva-reservering]");
    if (res) {
      var tijd = res.querySelector("[data-mva-res-tijd]"), tekst = res.querySelector("[data-mva-res-tekst]");
      var over = (Number(res.dataset.minuten) || 9) * 60;
      var teller = setInterval(function () {
        over--;
        if (tijd) tijd.textContent = tc(Math.floor(over / 60)) + ":" + tc(over % 60);
        if (over > 0) return;
        clearInterval(teller);
        res.classList.add("is-verlopen");
        if (tekst) tekst.textContent = res.dataset.verlopen;
      }, 1000);
    }
  }

  // ── Reviews: extra kaarten openklappen ──
  function initReviews(root) {
    var knop = root.querySelector("[data-mva-meer]");
    var grid = root.querySelector("[data-mva-revgrid]");
    var na = root.querySelector("[data-mva-meer-op]");
    if (!knop || !grid) return;
    knop.addEventListener("click", function () {
      grid.classList.add("is-open");
      knop.hidden = true;
      if (na) na.hidden = false;
    });
  }

  // ── Video's die alleen in beeld spelen (kaarten, split) ──
  function initInBeeld(root) {
    var clips = root.querySelectorAll("video[data-mva-inbeeld], [data-mva-inbeeld] video");
    if (!clips.length) return;
    var rustig = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (rustig || !("IntersectionObserver" in window)) return;
    var kijker = new IntersectionObserver(function (rijen) {
      rijen.forEach(function (r) {
        var v = r.target;
        if (!r.isIntersecting) { v.pause(); return; }
        if (v.preload !== "auto") { v.preload = "auto"; v.load(); }
        v.play().catch(function () {});
      });
    }, { threshold: 0.4, rootMargin: "200px 0px" });
    clips.forEach(function (c) { c.muted = true; kijker.observe(c); });
  }

  // ── Bundelbouwer ──
  function initBouwer(root) {
    var data;
    try { data = JSON.parse(root.querySelector("[data-mva-data]").textContent); }
    catch (e) { console.error("[mv-aanbod] bouwerdata onleesbaar", e); return; }
    var T = data.tekst;
    var geld = geldFormat(data.valuta);
    var q = function (sel) { return root.querySelector(sel); };

    // Optie-volgorde: kleur en maat herkennen aan de naam, anders de eerste en tweede optie.
    var namen = (data.opties || []).map(function (n) { return String(n).toLowerCase(); });
    var kI = namen.findIndex(function (n) { return /colou?r|kleur/.test(n); });
    var mI = namen.findIndex(function (n) { return /size|maat/.test(n); });
    if (kI < 0) kI = 0;
    if (mI < 0) mI = kI === 0 ? 1 : 0;
    var VAR = {}, KLEUREN = [], MATEN = [], BEELD = {};
    data.varianten.forEach(function (v) {
      var k = v.opties[kI], m = v.opties[mI] != null ? v.opties[mI] : "";
      if (KLEUREN.indexOf(k) < 0) KLEUREN.push(k);
      if (MATEN.indexOf(m) < 0) MATEN.push(m);
      (VAR[k] = VAR[k] || {})[m] = v;
      if (!BEELD[k]) BEELD[k] = (data.kleurbeelden || {})[k] || v.beeld;
    });
    var eerste = data.varianten[0] || { prijs: 0, advies: 0 };
    var STUK = eerste.prijs, ADVIES = Math.max(eerste.advies || 0, STUK);

    // Alleen bundels met korting tellen mee, net als in de kortingsconfig.
    var BARS = (data.bars || []).filter(function (b) { return b.totaal != null || b.betaald != null; })
      .sort(function (a, b) { return a.aantal - b.aantal; });
    function barVoor(n) {
      var uit = null;
      BARS.forEach(function (b) { if (b.aantal <= n) uit = b; });
      return uit;
    }
    function teBetalen(n) {
      var sub = n * STUK, b = barVoor(n);
      if (!b || !n) return sub;
      var per = b.totaal != null ? b.totaal / b.aantal : (sub / n) * (b.betaald / b.aantal);
      var korting = Math.min(sub, sub - Math.round(per * n));
      return korting > 0 ? sub - korting : sub;
    }
    function gratisStuks(n) {
      if (!STUK) return 0;
      var g = (n * STUK - teBetalen(n)) / STUK;
      return Math.abs(g - Math.round(g)) * STUK < 1 ? Math.round(g) : 0;
    }
    function exactGratis(n) {
      if (!STUK) return false;
      var g = (n * STUK - teBetalen(n)) / STUK;
      return g > 0.5 && Math.abs(g - Math.round(g)) * STUK < 1;
    }
    function besparing(n) { return n * ADVIES - teBetalen(n); }
    function volgendeTrede(n) {
      for (var i = 0; i < BARS.length; i++) if (BARS[i].aantal > n) return BARS[i].aantal;
      return 0;
    }
    function cadeauVoor(n) { var b = barVoor(n); return b && b.cadeau ? b.cadeau : null; }

    var mand = {}, maten = {}, eigen = {}, mijnMaat = "", wijzigt = "", stap = 1;
    function aantal() { return KLEUREN.reduce(function (t, k) { return t + (mand[k] || 0); }, 0); }
    function kanIn(k, m) { return !!(VAR[k] && VAR[k][m] && VAR[k][m].op); }
    function foto(k) {
      return BEELD[k] ? '<img src="' + esc(BEELD[k]) + '" alt="" loading="lazy" width="120" height="120">' : "";
    }
    function verzendRegel(bedrag) {
      var el = q("[data-mva-b-verzend]");
      if (!el) return;
      var datum = "<b>" + esc(verzenddatum(data.cutoff)) + "</b>";
      var tekst = bedrag >= data.gratisVanaf && data.gratisVanaf > 0 ? T.verzendGratis : T.verzend;
      el.innerHTML = vul(esc(tekst), { date: datum });
    }
    function gratisRegel(n) {
      var vak = q("[data-mva-b-gratis]");
      if (!n) { vak.hidden = true; return; }
      var uit = "";
      if (gratisStuks(n)) {
        uit = '<span class="ok">' + esc(exactGratis(n) ? vul(T.jeBetaaltVoor, { n: n - gratisStuks(n) }) : vul(T.jeBetaalt, { price: geld(teBetalen(n)) })) + "</span>";
      }
      var doel = volgendeTrede(n);
      if (doel) {
        var meerKost = teBetalen(doel) - teBetalen(n);
        if (doel - n === 1) {
          uit += '<span class="stap">' + (meerKost < 1 ? esc(T.stapGratis) : esc(vul(T.stapPrijs, { price: geld(meerKost) }))) + "</span>";
        } else {
          uit += '<span class="stap">' + esc(vul(T.stapMeer, { n: doel, m: doel - gratisStuks(doel) })) + "</span>";
        }
      }
      vak.innerHTML = uit;
      vak.hidden = !uit;
    }

    function naarStap(n) {
      stap = n;
      root.querySelectorAll("[data-mva-stap]").forEach(function (el) { el.hidden = el.dataset.mvaStap !== String(n); });
      q("[data-mva-totaal]").hidden = n !== 3;
      q("[data-mva-titel]").textContent = n === 1 ? T.titelMaat : n === 2 ? T.titelKleur : T.titelSet;
      q("[data-mva-cta-pijl]").hidden = n === 3;
      if (n === 1) {
        q("[data-mva-cta]").disabled = true;
        q("[data-mva-cta-tekst]").textContent = T.ctaMaat;
        q("[data-mva-melding]").hidden = true;
        gratisRegel(0);
        verzendRegel(0);
        tekenMaatgrid();
      }
      if (n === 2) { bouwKleuren(); tekenKleuren(); }
      if (n === 3) tekenSet();
      q("[data-mva-body]").scrollTop = 0;
    }

    function tekenMaatgrid() {
      q("[data-mva-matengrid]").innerHTML = MATEN.map(function (m) {
        var op = KLEUREN.some(function (k) { return kanIn(k, m); });
        return '<button type="button" aria-pressed="' + (m === mijnMaat) + '" data-maat="' + esc(m) + '"' + (op ? "" : " disabled") + ">" + esc(m) + "</button>";
      }).join("");
    }

    function bouwKleuren() {
      q("[data-mva-kleurlijst]").innerHTML = KLEUREN.map(function (k) {
        var kan = kanIn(k, mijnMaat);
        return '<div class="mva-kleurrij' + (kan ? "" : " is-op") + '" data-kleur="' + esc(k) + '">' + foto(k) +
          '<span class="mva-kleurrij__info"><span class="mva-kleurrij__naam">' + esc(k) + "</span>" +
          (kan
            ? (T.scoreKort ? '<span class="mva-kleurrij__sub"><span class="mva-sterren" aria-hidden="true">★</span> ' + esc(T.scoreKort) + "</span>" : "")
            : '<span class="mva-kleurrij__sub">' + esc(vul(T.uitverkochtInMaat, { size: mijnMaat })) + "</span>") +
          '</span><span class="mva-stepper"><button type="button" data-min disabled aria-label="−">−</button>' +
          '<span class="mva-stepper__n">0</span><button type="button" data-plus aria-label="+">+</button></span></div>';
      }).join("");
      q("[data-mva-maatpil]").innerHTML = esc(vul(T.maatPil, { size: mijnMaat })) + " <u>" + esc(T.maatWijzig) + "</u>";
    }

    function tekenKleuren() {
      root.querySelectorAll(".mva-kleurrij").forEach(function (rij) {
        var n = mand[rij.dataset.kleur] || 0;
        rij.querySelector(".mva-stepper__n").textContent = n;
        rij.querySelector("[data-min]").disabled = n === 0;
        rij.classList.toggle("is-gekozen", n > 0);
      });
      var n = aantal();
      gratisRegel(n);
      verzendRegel(teBetalen(n));
      var cta = q("[data-mva-cta]");
      cta.disabled = n === 0;
      q("[data-mva-cta-tekst]").textContent = n === 0 ? T.ctaKleur : vul(T.ctaVerder, { amount: geld(besparing(n)) });
    }

    function tekenSet() {
      var n = aantal(), gratis = gratisStuks(n), exact = exactGratis(n);
      var vanafGratis = n - gratis, i = 0;
      var perStuk = n ? Math.round(teBetalen(n) / n) : 0;
      var regels = "";
      KLEUREN.forEach(function (k) {
        for (var j = 0; j < (mand[k] || 0); j++) {
          var isGratis = exact && i >= vanafGratis;
          i++;
          regels += '<div class="mva-setregel">' + foto(k) +
            '<span class="mva-setregel__info"><span class="mva-setregel__naam">' + esc(k) + "</span>" +
            '<span class="mva-setregel__maat">' + esc(vul(T.setMaat, { size: maten[k + "#" + j] || "-" })) + "</span>" +
            '<button class="mva-setregel__wijzig" type="button" data-wijzig="' + esc(k + "#" + j) + '">' + esc(T.wijzig) + "</button></span>" +
            (isGratis
              ? '<span class="mva-setregel__prijs"><b class="is-gratis">' + esc(T.gratis) + "</b><s>" + geld(STUK) + '</s><span class="mva-setregel__waarom">' + esc(T.gratisWaarom) + "</span></span>"
              : '<span class="mva-setregel__prijs"><b>' + geld(exact ? STUK : perStuk) + "</b>" + (ADVIES > (exact ? STUK : perStuk) ? "<s>" + geld(ADVIES) + "</s>" : "") + "</span>") +
            "</div>";
        }
      });
      var cadeau = cadeauVoor(n);
      if (cadeau) {
        regels += '<div class="mva-setregel mva-setregel--cadeau">' +
          (cadeau.beeld ? '<img src="' + esc(cadeau.beeld) + '" alt="" loading="lazy" width="120" height="120">' : "") +
          '<span class="mva-setregel__info"><span class="mva-setregel__naam">' + esc(cadeau.naam) + "</span></span>" +
          '<span class="mva-setregel__prijs"><b class="is-gratis">' + esc(T.gratis) + "</b><s>" + geld(cadeau.prijs) + '</s><span class="mva-setregel__waarom">' + esc(T.cadeau) + "</span></span></div>";
      }
      q("[data-mva-setregels]").innerHTML = regels;
      q("[data-mva-setaantal]").textContent = n;
      gratisRegel(n);

      var doel = volgendeTrede(n), nudge = q("[data-mva-nudge]");
      if (!doel) {
        nudge.hidden = true;
        q("[data-mva-bijkiezer]").hidden = true;
      } else {
        nudge.hidden = false;
        var rest = doel - n;
        var gratisErbij = gratisStuks(doel) - gratisStuks(n);
        var extra = teBetalen(doel) - teBetalen(n);
        var zin = rest === 1
          ? (extra < 1 ? esc(T.nudgeEenGratis) : esc(vul(T.nudgeEenPrijs, { price: "\u0001" })).replace("\u0001", "<em>" + geld(extra) + "</em>"))
          : esc(gratisErbij === 1 ? vul(T.nudgeMeerEen, { n: rest }) : vul(T.nudgeMeerVeel, { n: rest, free: gratisErbij }));
        q("[data-mva-nudgetekst]").innerHTML = zin;
        q("[data-mva-nudgeknop]").textContent = rest === 1 ? T.nudgeKnopEen : vul(T.nudgeKnopMeer, { n: rest });
      }

      var waarde = n * ADVIES, pay = teBetalen(n), besp = besparing(n);
      q("[data-mva-totaal]").hidden = false;
      q("[data-mva-t-waarde]").textContent = geld(waarde);
      q("[data-mva-t-besp]").textContent = geld(besp);
      q("[data-mva-t-pct]").textContent = waarde ? "-" + Math.round(besp / waarde * 100) + "%" : "";
      q("[data-mva-t-pay]").textContent = geld(pay);
      verzendRegel(pay);
      q("[data-mva-cta-tekst]").textContent = T.ctaCheckout;
      q("[data-mva-cta]").disabled = n === 0;
    }

    function tekenSheetgrid() {
      var kleur = wijzigt.split("#")[0], huidig = maten[wijzigt];
      q("[data-mva-sheetkop]").textContent = vul(T.sheetTitel, { color: kleur });
      q("[data-mva-sheetgrid]").innerHTML = MATEN.map(function (m) {
        return '<button type="button" aria-pressed="' + (m === huidig) + '" data-smaat="' + esc(m) + '"' + (kanIn(kleur, m) ? "" : " disabled") + ">" + esc(m) + "</button>";
      }).join("");
      var weg = MATEN.filter(function (m) { return !kanIn(kleur, m); });
      q("[data-mva-sheetnoot]").textContent = weg.length ? vul(T.sheetNoot, { color: kleur }) : "";
    }

    function tekenBijraster() {
      q("[data-mva-bijraster]").innerHTML = KLEUREN.map(function (k) {
        var kan = kanIn(k, mijnMaat);
        return '<button class="mva-bijtegel" type="button" data-bij="' + esc(k) + '"' + (kan ? "" : " disabled") + ">" + foto(k) +
          "<span>" + esc(k) + (kan ? "" : "<br>" + esc(T.tegelOp)) + "</span></button>";
      }).join("");
    }

    function kiesMaat(m) {
      if (!m || !KLEUREN.some(function (k) { return kanIn(k, m); })) return;
      var oude = mijnMaat, eruit = [];
      mijnMaat = m;
      if (oude && oude !== m) {
        // Kleuren die deze maat niet hebben gaan uit de set, met een melding (nooit stil laten vallen).
        KLEUREN.forEach(function (k) {
          if (mand[k] && !kanIn(k, m)) {
            eruit.push(k);
            for (var i = 0; i < mand[k]; i++) { delete maten[k + "#" + i]; delete eigen[k + "#" + i]; }
            delete mand[k];
          }
        });
        KLEUREN.forEach(function (k) {
          for (var i = 0; i < (mand[k] || 0); i++) if (!eigen[k + "#" + i]) maten[k + "#" + i] = m;
        });
      }
      naarStap(2);
      var mld = q("[data-mva-melding]");
      mld.hidden = !eruit.length;
      if (eruit.length) mld.textContent = vul(T.uitDeSet, { size: m, colors: eruit.join(", ") });
    }

    // Openen en sluiten. Het scrollslot volgt de class, wat er ook gebeurt.
    function syncSlot() { document.body.style.overflow = root.classList.contains("is-open") ? "hidden" : ""; }
    new MutationObserver(syncSlot).observe(root, { attributes: true, attributeFilter: ["class"] });
    window.addEventListener("pageshow", syncSlot);
    function open() {
      if (!mijnMaat) naarStap(1);
      root.classList.add("is-open");
      root.setAttribute("aria-hidden", "false");
      var terug = q("[data-mva-terug]");
      if (terug) terug.focus();
    }
    function sluit() {
      root.classList.remove("is-open");
      root.setAttribute("aria-hidden", "true");
    }
    root.mvaOpen = open;
    root.mvaSluit = sluit;
    root.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var laag = root.querySelector(".mva-laag.is-open");
      if (laag) laag.classList.remove("is-open"); else sluit();
    });

    q("[data-mva-matengrid]").addEventListener("click", function (e) {
      var b = e.target.closest("[data-maat]");
      if (!b || b.disabled) return;
      root.querySelectorAll("[data-mva-matengrid] button").forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
      setTimeout(function () { kiesMaat(b.dataset.maat); }, 140);
    });
    q("[data-mva-kleurlijst]").addEventListener("click", function (e) {
      var rij = e.target.closest(".mva-kleurrij");
      if (!rij) return;
      var k = rij.dataset.kleur;
      if (!kanIn(k, mijnMaat)) return;
      if (e.target.closest("[data-plus]")) {
        maten[k + "#" + (mand[k] || 0)] = mijnMaat;
        mand[k] = (mand[k] || 0) + 1;
      }
      if (e.target.closest("[data-min]") && mand[k]) {
        mand[k] -= 1;
        delete maten[k + "#" + mand[k]];
        delete eigen[k + "#" + mand[k]];
      }
      tekenKleuren();
    });
    q("[data-mva-maatpil]").addEventListener("click", function () { naarStap(1); });
    q("[data-mva-terug]").addEventListener("click", function () { if (stap > 1) naarStap(stap - 1); else sluit(); });
    q("[data-mva-nudgeknop]").addEventListener("click", function () {
      var vak = q("[data-mva-bijkiezer]");
      tekenBijraster();
      vak.hidden = false;
      vak.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
    q("[data-mva-bijraster]").addEventListener("click", function (e) {
      var b = e.target.closest("[data-bij]");
      if (!b || b.disabled) return;
      var k = b.dataset.bij;
      maten[k + "#" + (mand[k] || 0)] = mijnMaat;
      mand[k] = (mand[k] || 0) + 1;
      tekenSet();
      tekenBijraster();
    });

    var sheet = q("[data-mva-sheet]");
    q("[data-mva-setregels]").addEventListener("click", function (e) {
      var b = e.target.closest("[data-wijzig]");
      if (!b) return;
      wijzigt = b.dataset.wijzig;
      tekenSheetgrid();
      sheet.classList.add("is-open");
    });
    q("[data-mva-sheetgrid]").addEventListener("click", function (e) {
      var b = e.target.closest("[data-smaat]");
      if (!b || b.disabled) return;
      maten[wijzigt] = b.dataset.smaat;
      eigen[wijzigt] = b.dataset.smaat !== mijnMaat;
      tekenSheetgrid();
      setTimeout(function () { sheet.classList.remove("is-open"); tekenSet(); }, 140);
    });
    root.querySelectorAll("[data-mva-sheet-sluit]").forEach(function (x) {
      x.addEventListener("click", function () { sheet.classList.remove("is-open"); });
    });

    // Afrekenen: stuks met _mv_bundel (en het cadeau met _mv_cadeau) via /cart/add.js, dan naar de checkout.
    var bezig = false;
    q("[data-mva-cta]").addEventListener("click", function () {
      if (stap === 2) { naarStap(3); return; }
      if (stap !== 3 || bezig) return;
      var perVariant = {}, mist = [], n = 0;
      KLEUREN.forEach(function (k) {
        for (var i = 0; i < (mand[k] || 0); i++) {
          var m = maten[k + "#" + i];
          if (m && kanIn(k, m)) { var id = VAR[k][m].id; perVariant[id] = (perVariant[id] || 0) + 1; n++; }
          else mist.push(k);
        }
      });
      var tekst = q("[data-mva-cta-tekst]");
      if (mist.length) { tekst.textContent = vul(T.ctaMist, { color: mist[0] }); return; }
      if (!n) return;
      var sleutel = "aanbod:" + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      var items = Object.keys(perVariant).map(function (id) {
        return { id: Number(id), quantity: perVariant[id], properties: { _mv_bundel: sleutel } };
      });
      var cadeau = cadeauVoor(n);
      if (cadeau) items.push({ id: cadeau.id, quantity: 1, properties: { _mv_cadeau: sleutel } });
      bezig = true;
      var cta = q("[data-mva-cta]");
      cta.disabled = true;
      tekst.textContent = T.ctaBezig;
      var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      fetch(routes + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j }; });
      }).then(function (uit) {
        if (!uit.ok || uit.j.status) throw new Error(uit.j.description || uit.j.message || "cart/add failed");
        window.location.href = routes + "checkout";
      }).catch(function (fout) {
        console.error("[mv-aanbod] toevoegen mislukt", fout);
        bezig = false;
        cta.disabled = false;
        tekst.textContent = T.fout;
      });
    });

    // Maatvenster en maattabel uit het maattabel-metaobject (rekenmachine: banden met cups -> maat).
    var calc = data.rekenmachine, gids = q("[data-mva-gids]");
    var gBand = q("[data-mva-band]"), gCup = q("[data-mva-cup]");
    if (calc && calc.banden && gBand && gCup) {
      var CUPS = [];
      calc.banden.forEach(function (b) {
        gBand.add(new Option(b.label, b.waarde));
        (b.cups || []).forEach(function (c) { if (CUPS.indexOf(c[0]) < 0) CUPS.push(c[0]); });
      });
      if (!CUPS.length) gCup.closest("span").hidden = true;
      CUPS.forEach(function (c) { gCup.add(new Option(c, c)); });
      var maatVoor = function (band, cup) {
        var b = calc.banden.filter(function (x) { return x.waarde === band; })[0];
        if (!b) return "";
        if (!b.cups) return b.maat || "";
        var c = b.cups.filter(function (x) { return x[0] === cup; })[0];
        return c ? c[1] : "";
      };
      var uitslag = function () {
        var vak = q("[data-mva-uitslag]"), b = gBand.value, c = CUPS.length ? gCup.value : "";
        var label = (calc.banden.filter(function (x) { return x.waarde === b; })[0] || {}).label || b;
        if (!b || (CUPS.length && !c)) {
          vak.className = "mva-uitslag is-leeg";
          vak.innerHTML = '<span class="mva-uitslag__maat">' + esc(T.rekenLeeg) + "</span>";
        } else {
          var maat = maatVoor(b, c), bh = label + c;
          if (!maat || MATEN.indexOf(maat) < 0 || !KLEUREN.some(function (k) { return kanIn(k, maat); })) {
            vak.className = "mva-uitslag is-leeg";
            vak.innerHTML = '<span class="mva-uitslag__maat">' + esc(maat || T.rekenGeen) + '</span><span class="mva-uitslag__bij">' + esc(vul(T.rekenGeenSub, { size: bh })) + "</span>";
          } else {
            vak.className = "mva-uitslag";
            vak.innerHTML = '<span class="mva-uitslag__maat">' + esc(maat) + '</span><span class="mva-uitslag__bij">' + esc(vul(T.rekenPast, { size: bh })) + '</span><button class="mva-uitslag__knop" type="button" data-neem="' + esc(maat) + '">' + esc(T.rekenNeem) + "</button>";
          }
        }
        tekenTabel();
      };
      var tekenTabel = function () {
        var tabel = q("[data-mva-tabel]");
        if (!tabel) return;
        var kop = "<thead><tr><th>" + esc(T.tabelBand) + "</th>" + calc.banden.map(function (b) { return "<th>" + esc(b.label) + "</th>"; }).join("") + "</tr></thead>";
        var rijen = (CUPS.length ? CUPS : [""]).map(function (cup) {
          return "<tr><th>" + esc(cup) + "</th>" + calc.banden.map(function (b) {
            var m = maatVoor(b.waarde, cup);
            var raak = b.waarde === gBand.value && cup === (CUPS.length ? gCup.value : "");
            return '<td class="' + (m ? (raak ? "is-raak" : "") : "is-leeg") + '">' + esc(m || "-") + "</td>";
          }).join("") + "</tr>";
        }).join("");
        tabel.innerHTML = kop + "<tbody>" + rijen + "</tbody>";
      };
      gBand.addEventListener("change", uitslag);
      gCup.addEventListener("change", uitslag);
      q("[data-mva-uitslag]").addEventListener("click", function (e) {
        var b = e.target.closest("[data-neem]");
        if (!b) return;
        if (gids) gids.classList.remove("is-open");
        kiesMaat(b.dataset.neem);
      });
      tekenTabel();
    }
    root.querySelectorAll("[data-mva-gids-open]").forEach(function (x) {
      x.addEventListener("click", function () { if (gids) gids.classList.add("is-open"); });
    });
    root.querySelectorAll("[data-mva-gids-sluit]").forEach(function (x) {
      x.addEventListener("click", function () { if (gids) gids.classList.remove("is-open"); });
    });

    naarStap(1);
  }

  var INIT = { kop: initKop, hero: initHero, reviews: initReviews, bouwer: initBouwer };
  function start(binnen) {
    (binnen || document).querySelectorAll("[data-mva]").forEach(function (el) {
      if (el.dataset.mvaKlaar) return;
      el.dataset.mvaKlaar = "1";
      var f = INIT[el.dataset.mva];
      try {
        if (f) f(el);
        initInBeeld(el);
      } catch (e) { console.error("[mv-aanbod] " + el.dataset.mva, e); }
    });
    vulVerzenddata();
  }

  window.mvAanbod = { start: start };

  // Elke knop met data-mva-open opent de bouwer; zonder bouwer op de pagina volgt hij gewoon zijn link.
  document.addEventListener("click", function (e) {
    var knop = e.target.closest("[data-mva-open]");
    if (!knop) return;
    var bouwer = document.querySelector("[data-mva-bouwer]");
    if (!bouwer || typeof bouwer.mvaOpen !== "function") return;
    e.preventDefault();
    bouwer.mvaOpen();
  });

  // Theme editor: secties opnieuw opstarten na een herlaadbeurt, en de bouwer tonen als je hem selecteert.
  document.addEventListener("shopify:section:load", function (e) { start(e.target); });
  document.addEventListener("shopify:section:select", function (e) {
    var b = e.target.querySelector("[data-mva-bouwer]");
    if (b && b.mvaOpen) b.mvaOpen();
  });
  document.addEventListener("shopify:section:deselect", function (e) {
    var b = e.target.querySelector("[data-mva-bouwer]");
    if (b && b.mvaSluit) b.mvaSluit();
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { start(); });
  else start();
})();
